import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { FileSelectorModal as x, FileTypeEnum as p } from "@systemeio/file-manager";
import { Tooltip as v, toast as E } from "@systemeio/ui";
import { useEditorState as F } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as M, useMemo as N, Fragment as S } from "react";
import { ToolbarButton as g } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as f, TOOLTIP_STYLES as y } from "../../constants/default-styles.mjs";
import { ImageModeEnum as C } from "./image-enum.mjs";
import b from "../../icons/image-icon.mjs";
import { InsertImageViaLink as I } from "./insert-image-via-link.mjs";
import { useTranslation as O } from "../../i18n.mjs";
import { ImageBubbleMenu as k } from "./image-bubble-menu.mjs";
const z = (t, i) => {
  const { t: s } = O(), [c, l] = M(!1), d = F({
    editor: t,
    selector: ({ editor: r }) => ({
      isEditable: (r == null ? void 0 : r.options.editable) ?? !1
    })
  }), e = !(d != null && d.isEditable);
  return N(() => {
    const r = (a) => {
      if (!t) return null;
      const u = () => t.chain().focus().run();
      if (!a) return u();
      const n = new Image();
      n.src = a, n.onerror = () => {
        E.error(s("image_error")), u();
      }, n.onload = () => {
        const h = n.naturalWidth, T = n.naturalHeight;
        t.chain().focus().setImage({
          src: a,
          imageMode: C.BlockCenter,
          containerWidth: "auto",
          width: h,
          height: T
        }).run(), l(!1);
      };
    };
    return {
      toolbarRender: /* @__PURE__ */ m("div", { className: "hover:divide-text-secondary/30 flex divide-x divide-transparent", children: [
        /* @__PURE__ */ o(v, { disabled: e, label: s("image"), ...y, children: /* @__PURE__ */ o(g, { disabled: e, onClick: () => l(!0), children: /* @__PURE__ */ o(b, { className: f(e) }) }) }),
        /* @__PURE__ */ o(I, { handleSetImage: r, isDisabled: e })
      ] }),
      tooltipRender: /* @__PURE__ */ m("div", { className: "divide-text-secondary/30 flex divide-x", children: [
        /* @__PURE__ */ m(
          g,
          {
            className: "gap-1.5",
            disabled: e,
            onClick: () => l(!0),
            children: [
              /* @__PURE__ */ o(b, { className: f(e) }),
              s("image")
            ]
          }
        ),
        /* @__PURE__ */ o(I, { handleSetImage: r, isDisabled: e })
      ] }),
      additionalRender: /* @__PURE__ */ m(S, { children: [
        /* @__PURE__ */ o(
          x,
          {
            initialSearchFilters: {
              name: "",
              source: [i],
              type: [p.Image, p.ImageOther]
            },
            opened: c,
            onClose: () => l(!1),
            onSelect: ({ path: a }) => r(a),
            uploadingFromSource: i,
            disabledFileTypeSelect: !0
          }
        ),
        /* @__PURE__ */ o(k, { editor: t, fileSource: i })
      ] })
    };
  }, [e, c, t, i, s]);
};
export {
  z as useImageExtensionToolbar
};
